import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApplicationConfigService } from '../config/application-config.service';
import {Logout} from '../../login/logout.model';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
  constructor(private http: HttpClient, private applicationConfigService: ApplicationConfigService) {}

  logout(token: string): Observable<Logout> {
    const body = new HttpParams().set('idToken', token);
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    return this.http.post<Logout>(
        this.applicationConfigService.getEndpointFor('api/logout'),
        body.toString(),
        { headers }
    );
  }
}
